// CURRENCY SYMBOL
export const CURRENCY = 'USD';

// Template Unique Prefix
export const PREFIX = "san-marino";